export default __webpack_public_path__ + "static/topic2-fc2e37c12a94be447fd9602454fb4faa.png";